import React from "react";
import { _ } from "libs";

const LoginButton = ({
	text = _("nav.sign_in"),
	onClick,
	className,
}: {
	text?: string;
	onClick;
	className: string;
}) => {
	return (
		<button className={className} onClick={onClick}>
			{text}
		</button>
	);
};

export default LoginButton;
